export default __webpack_public_path__ + "static/media/arrow-long-right-grey.994c15cb.svg";